module.exports = __webpack_public_path__ + "img/snb_bsgs.2ad7b017.svg";